/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FejlDashboardTypeEnum as OkEgisServiceModelsDtoEnumsFejlDashboardTypeEnum } from '../models/OK/Egis/Service/Models/DTO/Enums/fejl-dashboard-type-enum';
import { FejlDashboardSummaryDto as OkEgisServiceModelsDtoFejlDashboardSummaryDto } from '../models/OK/Egis/Service/Models/DTO/fejl-dashboard-summary-dto';
import { FejlDashbordRetFejlRequest as OkEgisServiceModelsRequestFejlDashbordRetFejlRequest } from '../models/OK/Egis/Service/Models/Request/fejl-dashbord-ret-fejl-request';
import { GetFejlDashboardDtoResponse as OkEgisServiceModelsResponseGetFejlDashboardDtoResponse } from '../models/OK/Egis/Service/Models/Response/get-fejl-dashboard-dto-response';

@Injectable({
  providedIn: 'root',
})
export class FejlDashboardService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation fejlDashboardSummary
   */
  static readonly FejlDashboardSummaryPath = '/api/v1/FejlDashboard/FejlDashboardSummary';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fejlDashboardSummary()` instead.
   *
   * This method doesn't expect any request body.
   */
  fejlDashboardSummary$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoFejlDashboardSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, FejlDashboardService.FejlDashboardSummaryPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoFejlDashboardSummaryDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fejlDashboardSummary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fejlDashboardSummary(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoFejlDashboardSummaryDto> {

    return this.fejlDashboardSummary$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoFejlDashboardSummaryDto>) => r.body as OkEgisServiceModelsDtoFejlDashboardSummaryDto)
    );
  }

  /**
   * Path part for operation fejlDashboardSubSummary
   */
  static readonly FejlDashboardSubSummaryPath = '/api/v1/FejlDashboard/FejlDashboardSubSummary';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fejlDashboardSubSummary()` instead.
   *
   * This method doesn't expect any request body.
   */
  fejlDashboardSubSummary$Response(params: {
    type?: OkEgisServiceModelsDtoEnumsFejlDashboardTypeEnum;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoFejlDashboardSummaryDto>> {

    const rb = new RequestBuilder(this.rootUrl, FejlDashboardService.FejlDashboardSubSummaryPath, 'get');
    if (params) {
      rb.query('type', params.type, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoFejlDashboardSummaryDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fejlDashboardSubSummary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fejlDashboardSubSummary(params: {
    type?: OkEgisServiceModelsDtoEnumsFejlDashboardTypeEnum;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoFejlDashboardSummaryDto> {

    return this.fejlDashboardSubSummary$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoFejlDashboardSummaryDto>) => r.body as OkEgisServiceModelsDtoFejlDashboardSummaryDto)
    );
  }

  /**
   * Path part for operation fejlDashboardListe
   */
  static readonly FejlDashboardListePath = '/api/v1/FejlDashboard/FejlDashboardListe';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fejlDashboardListe()` instead.
   *
   * This method doesn't expect any request body.
   */
  fejlDashboardListe$Response(params: {
    type?: OkEgisServiceModelsDtoEnumsFejlDashboardTypeEnum;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseGetFejlDashboardDtoResponse>> {

    const rb = new RequestBuilder(this.rootUrl, FejlDashboardService.FejlDashboardListePath, 'get');
    if (params) {
      rb.query('type', params.type, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseGetFejlDashboardDtoResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fejlDashboardListe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fejlDashboardListe(params: {
    type?: OkEgisServiceModelsDtoEnumsFejlDashboardTypeEnum;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsResponseGetFejlDashboardDtoResponse> {

    return this.fejlDashboardListe$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseGetFejlDashboardDtoResponse>) => r.body as OkEgisServiceModelsResponseGetFejlDashboardDtoResponse)
    );
  }

  /**
   * Path part for operation retFejlDashboardListe
   */
  static readonly RetFejlDashboardListePath = '/api/v1/FejlDashboard/RetFejlDashboardListe';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retFejlDashboardListe()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  retFejlDashboardListe$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestFejlDashbordRetFejlRequest
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, FejlDashboardService.RetFejlDashboardListePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `retFejlDashboardListe$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  retFejlDashboardListe(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestFejlDashbordRetFejlRequest
  }): Observable<void> {

    return this.retFejlDashboardListe$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
